export const ACCOUNT = '/account'
export const AUTH = '/auth'
export const GET_NEXT = '/get-next'
export const HANDLE_AUTH = '/handle-auth'
export const LANDING = '/'
export const SIGN_UP = '/sign-up'
export const IN_STOCK = '/in-stock'